import { CLOSE_WINDOW, OPEN_WINDOW } from '../actionTypes/LoginModalWindow';

export type WindowCreateUser = {
    isShow: boolean
};

export type TSetOpenWindow = {
    type: typeof OPEN_WINDOW,
}

export type TSetCloseWindow = {
    type: typeof CLOSE_WINDOW,
}


const initialState:WindowCreateUser = { isShow:false };

export type TActions = TSetOpenWindow | TSetCloseWindow;

export const WindowCreator = (state = initialState, action: TActions): WindowCreateUser => {
    switch (action.type) {
        case OPEN_WINDOW: {
            return {
                ...state,
                isShow: !state.isShow
            };
        }
        default: return state;
    }
};
